// extracted by mini-css-extract-plugin
module.exports = {"guide":"CheckInquiry_guide__RvVx7","intro":"CheckInquiry_intro__vTlhg","intro_1":"CheckInquiry_intro_1__1s5Ji"};